import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import Ranking from "../pages/ranking/page";
import Guide from "../pages/guide/page";
import ReviewDetail from "../pages/review/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "ranking", element: <Ranking /> },
      { path: "guide", element: <Guide /> },
      { path: "review/:id", element: <ReviewDetail /> },
      { path: "about", element: <About /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;